export default "__VITE_ASSET__CqzQr1sV__"